import React from 'react';
import "./CustomUpdateMapCharges.css";
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import leftArrow from "../../../assests/leftArrow.svg"

const UpdateMapChargesComponent = (props) => {
  const navigate = useNavigate();

  const goback = () => {
    navigate(-1);
  };

  return (
    <div className="custom-charges-container">
      <Sidebar />
      <div className="custom-charges-content">
      
        <h2 className="custom-charges-title">   <img src={leftArrow} alt="" onClick={goback} />Edit Mapped Charges</h2>

        <div className="custom-card-wrapper">
          {props.updateMapCharges?.map((charge, index) => (
            <div key={charge.id} className="custom-card-box">
              <Card className="custom-charge-card">
                <div className="custom-card-header">
                  <Typography className="custom-card-title">
                    Charge Name {index + 1}
                  </Typography>
                  <input
                    type="checkbox"
                    checked={props.selectedChargeIds.includes(charge.id)}
                    onChange={() => props.handleCheckboxChange(charge.id)}
                    className="custom-charge-checkbox"
                  />
                </div>
                <CardContent>
                  <ul className="custom-charge-details">
                    <li>Id: {charge.id}</li>
                    <li>Name: {charge.name}</li>
                    <li>Description: {charge.description}</li>
                    <li>Beneficiary Type Id: {charge.beneficiaryTypeId}</li>
                    <li>Charge Type: {charge.chargeType}</li>
                    <li>Value Type: {charge.valueType}</li>
                    <li>Value: {charge.value}</li>
                    <li>Value Min: {charge.valueMin}</li>
                    <li>Value Max: {charge.valueMax}</li>
                  </ul>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        <div className="custom-charges-buttons">
          <Button variant="outlined" onClick={goback} className="custom-btn-back">Back</Button>
          <Button  onClick={props.handleUpdateMapCharges} className="custom-btn-remove">Remove</Button>
        </div>
      </div>
    </div>
  );
};

export default UpdateMapChargesComponent;
